export default "<app-base-header></app-base-header>\r\n<div class=\"flex justify-center items-center\">發生錯誤了</div>\r\n<app-base-footer></app-base-footer>\r\n";